import merge from 'lodash/merge';
import certificationPolicies from './certifications';
import impactClaimPolicies from './impactClaims';
import query from './query';

export default merge(query, impactClaimPolicies, certificationPolicies);
